import { TypographyColor } from 'melp-design/components';
import { PermissionName } from 'store/permissions';
import {
  SurveyAssignmentStatus,
  SurveyRatingScaleAnswerType,
  SurveyStatus,
  SurveyType,
} from './surveys.types';

/**
 * Surveys and trainings share UI, but are gated by different permissions.
 * Forms continue to use the surveys permission.
 */
export const getSurveyPermissionName = (
  type: SurveyType,
): Extract<PermissionName, 'surveys' | 'trainings'> =>
  type === 'training' ? 'trainings' : 'surveys';

export const COLOR_BY_STATUS: Record<SurveyStatus, TypographyColor> = {
  draft: 'textSecondary',
  pending: 'warning',
  in_progress: 'success',
  ended: 'textSecondary',
};

export const COLOR_BY_ASSIGNMENT_STATUS: Record<
  SurveyAssignmentStatus,
  TypographyColor
> = {
  on: 'success',
  off: 'textSecondary',
};

export const OPTIONS_BY_RATING_SCALE: Record<
  SurveyRatingScaleAnswerType,
  string[]
> = {
  rating_scale_numbers_5: ['1', '2', '3', '4', '5'],
  rating_scale_numbers_7: ['1', '2', '3', '4', '5', '6', '7'],
  rating_scale_numbers_10: [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
  ],
  rating_scale_emoji_3: ['🙁', '😐', '🙂'],
  rating_scale_emoji_5: ['😡', '🙁', '😐', '🙂', '😀'],
};

export const MAX_QUESTIONS_FOR_AI_GENERATION = 20;
